import styled from '@emotion/styled'
import Input from '../../components/common/Input'
import { BORDER } from '../../constant/colors'
import { useScreen } from '../../utils/responsive-helper'
import ProductCategoryList from './components/ProductCategoryList'
import ProductList from './components/ProductList'

const Layout = styled.div``

const Section = styled.div`
  margin: 16px 0;
`

const Product = () => {
  const { isMobile } = useScreen()

  return (
    <Layout>
      {isMobile && (
        <Section>
          <Input
            inputStyle={{ borderRadius: 100, backgroundColor: BORDER }}
            placeholder="ค้นหาสินค้าที่ต้องการ"
          />
        </Section>
      )}
      <ProductCategoryList />
      <ProductList isMobile={isMobile} />
    </Layout>
  )
}

export default Product
